import { createFileRoute } from '@tanstack/react-router'
import { CRT_ROUTES, toStaticData } from '../../crt-route-config'

export const Route = createFileRoute('/_auth/_modules/crt/admin/audit-trails')({
  staticData: toStaticData(CRT_ROUTES['/crt/admin/audit-trails']),
  beforeLoad: async ({ context }) => {
    context.handleRoutePermissions(Route)
  },
})
